import $ from '@sparta.global.vendors/jquery';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaTransportUtility from '@sparta.global.utilities/sparta-transport-utility/dist/es6.js';

class RatesUtility {
  /**
   * Return a Deferred of Autoloans Rates by providing a state
   * @param state: str, A 2 letter state code
   * @param isAuth: bool, if true it will hi the
   * @returns {*}
   */
  getAutoLoans(state, isAuth) {
    // const CACHE_NAME = 'autoRatesData';
    // const CACHE_STATE = 'autoRatesDataState';
    if (!state) {
      state = 'VA';
    }
    const deferred = $.Deferred();
    const endPoint = isAuth === true ? `${spaParams.siteParams.authRatesApi}=${state}` : `${spaParams.siteParams.unauthRatesApi}=${state}`;
    // let cache = spartaStoreUtility.getPersisted(CACHE_NAME, 'sessionStorage');
    // let cachedState = spartaStoreUtility.getPersisted(CACHE_STATE, 'sessionStorage');

    // if (state === cachedState && cache) {
    //   let cachedData = JSON.parse(cache);
    //   deferred.resolve(cachedData);
    //   if (cachedState != cachedData.state) {
    //     spartaStoreUtility.persist(CACHE_STATE, state, 'sessionStorage');
    //     return this._getAutoLoansRates(endPoint, CACHE_NAME);
    //   }
    // } else {
    //   if (state != cachedState) {
    //     spartaStoreUtility.persist(CACHE_STATE, state, 'sessionStorage');
    //     return this._getAutoLoansRates(endPoint, CACHE_NAME);
    //   } else if (!cache) {
    //     spartaStoreUtility.persist(CACHE_STATE, state, 'sessionStorage');
    //     return this._getAutoLoansRates(endPoint, CACHE_NAME);
    //   } else {
    //     deferred.resolve(JSON.parse(cache));
    //   }
    // }
    $.getJSON(endPoint).done(data => {
      deferred.resolve(data);
    }).fail(() => {
      deferred.reject(`unable to connect to ${endPoint}`);
    });
    return deferred;
  }
  _getAutoLoansRates(endPoint, cacheKey) {
    const deferred = $.Deferred();
    $.getJSON(endPoint).done(data => {
      spartaStoreUtility.persist(cacheKey, JSON.stringify(data), 'sessionStorage');
      deferred.resolve(data);
    }).fail(() => {
      deferred.reject(`unable to connect to ${endPoint}`);
    });
    return deferred;
  }
  getHomeMortgage() {}

  /**
   * Get Rate Feed Auto Loans - for MCOE
   */
  getRateFeedAutoLoans() {
    const state = spartaStoreUtility._getState();
    const subscription = {
      url: `https://homeloans5.bankofamerica.com/rateboard/ratefeedautoloan/?state=${state}`,
      method: 'GET',
      cache: false,
      timeout: 10000,
      // * important jsonp will not show up in xhr
      dataType: 'jsonp',
      success: this.getRateFeedSuccess,
      error: this.getRateFeedError
    };
    spartaTransportUtility.subscribe(subscription);
  }

  /**
   * Success
   * @param  {Object} data
   */
  getRateFeedSuccess(data) {
    spartaEventsUtility.pub('getRateFeedAutoLoansSuccess', {
      ...data
    });
  }

  /**
   * Error
   * @param  {Object} request
   */
  getRateFeedError(request) {
    spartaEventsUtility.pub('getRateFeedAutoLoansFailure', request);
  }
}
var index = new RatesUtility();

export { index as default };
